// extracted by mini-css-extract-plugin
export var bgWhite = "styles-module--bgWhite--kq07b";
export var cardWrapper = "styles-module--cardWrapper--4KGUW";
export var formWrapper = "styles-module--formWrapper--oPQ7D";
export var messageInput = "styles-module--messageInput--QIpmp";
export var section = "styles-module--section--wFUQV";
export var textWhite = "styles-module--textWhite--dilD-";